export const sendFeedbackDialogTitle = "N6BZNb";
export const sendFeedbackEmailSubject = "t$KLee";
export const sendFeedbackEmailContentStart = "E3Aird";
export default {sendFeedbackDialogTitle,sendFeedbackEmailSubject,sendFeedbackEmailContentStart};